import { createTRPCQueryUtils } from '@trpc/react-query';
import type { AppRoutes, RouterInputs, RouterOutputs } from '@/server/root';
import type { UpdateDefinition } from '@/types/global';
import type { NestedRoute } from '@/types/index.types';
import { queryClient } from '../tanstack-query/query-client';
import { trpcClient } from './client';

export const trpcUtils = createTRPCQueryUtils({
	queryClient,
	client: trpcClient,
});

export function updateDef<R extends AppRoutes, D extends AppRoutes>(
	u: UpdateDefinition<R, D>,
) {
	return u;
}

// INFO: When mutation inside meta is not enough
export function optimisticUpdate<R extends AppRoutes>(
	route: R,
	{
		input,
		updater,
	}: {
		input: NestedRoute<RouterInputs, R>;
		updater: (
			prevData: NestedRoute<RouterOutputs, R>,
		) => NestedRoute<RouterOutputs, R>;
	},
) {
	// @ts-expect-error route is typed;
	const queryKey = getQueryKey(api[route], input, 'query');
	queryClient.setQueryData(queryKey, (prevData: unknown) =>
		// @ts-expect-error Not using as generic like in global.d.ts;
		updater?.(prevData),
	);
}
